import styled from 'styled-components';

export const MainContainer = styled.div`
    
`;

export const AppLoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0,0,0,0.9);
`;